type Props = {
  titlex: string;
  classNamex: string;
};

export const BtnLink = ({ titlex, classNamex }: Props): JSX.Element => {
  return (
    <button type="button" className={classNamex}>
      {titlex}
    </button>
  );
};
